import React, { useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import cornerstone from 'cornerstone-core';
import cornerstoneTools from 'cornerstone-tools';

import { addMeasurement } from '../redux/manMeasurements';
import { useDispatch } from 'react-redux';

export default function ManualRegistrationImgViewer(props) {
  const { id, onMeasurement, imageElement } = props;
  const images = useSelector(state => state.images);
  
  const man_measurements = useSelector(state => state.man_measurements);
  
  const imageUrl = id=== "maia_tgz_file" ? images[id]?.rotated_url : images[id]?.url; // Here you can replace 'default_image_path' with your default or placeholder image path.
  
  const dispatch = useDispatch();
  //const imageElement = useRef(null);
  const contextMenuRef = useRef(null); // added contextMenu ref

  const [currentProbe, setCurrentProbe] = useState(null);

  const getToolsState = () => {
    // Get tool state for all enabled tools

    const points = cornerstoneTools.getToolState(imageElement.current, "Probe");
    dispatch(addMeasurement({
      name: id, value: JSON.parse(JSON.stringify(points))
    }))
    onMeasurement(id, points)
  }

  const onMeasurementAdded = (e) => {
    // Get tool state for all enabled tools on measurementAdded
    getToolsState()
  }

  const onMeasurementModified = (e) => {
    // Measurement modified
    getToolsState()
  }


  useEffect(() => {
    const element = imageElement.current;
    if (imageUrl === undefined) {return}
    cornerstone.loadImage(imageUrl)
      .then((image) => {
        cornerstone.enable(element);
        cornerstone.displayImage(element, image);

        cornerstoneTools.addTool(cornerstoneTools.ZoomMouseWheelTool);
        cornerstoneTools.setToolActive('ZoomMouseWheel', { mouseButtonMask: 1 });

        cornerstoneTools.addTool(cornerstoneTools.PanTool);
        cornerstoneTools.addTool(cornerstoneTools.ZoomTool);
        cornerstoneTools.addTool(cornerstoneTools.ProbeTool);

        // Activate tools
        cornerstoneTools.setToolActive('Pan', { mouseButtonMask: 2 });
        cornerstoneTools.setToolActive('Probe', { mouseButtonMask: 1 });

        element.addEventListener('cornerstonetoolsmeasurementadded', onMeasurementAdded);
        element.addEventListener('cornerstonetoolsmeasurementmodified', onMeasurementModified);
        cornerstoneTools.setToolActive('Pan', { mouseButtonMask: 2 });
        cornerstoneTools.setToolActive('Probe', { mouseButtonMask: 1 });

        element.addEventListener('contextmenu', handleRightClick);

        if (man_measurements[id]?.data.length > 0){
          cornerstoneTools.clearToolState(imageElement.current, 'Probe')
          man_measurements[id]?.data?.forEach(item => {
            cornerstoneTools.addToolState(imageElement.current, 'Probe', {
              visible: true,
              active: true,
              color: undefined,
              invalidated: true,
              handles: {
                end: {
                  x: item.handles.end.x,
                  y: item.handles.end.y,
                  highlight: true,
                  active: true,
                },
              },
            })
          });
        }

        return () => {
          element.removeEventListener('contextmenu', handleRightClick);
        };
      });

  }, [imageUrl]);

  const handleRightClick = (event) => {
    event.preventDefault();

    const probes = cornerstoneTools.getToolState(imageElement.current, 'Probe');

    if (probes && probes.data && probes.data.length > 0) {
      const clickCoords = cornerstone.pageToPixel(imageElement.current, event.pageX, event.pageY);
      let overProbe = null;

      probes.data.some(probe => {
        const distance = Math.sqrt(Math.pow(clickCoords.x - probe.handles.end.x, 2) + Math.pow(clickCoords.y - probe.handles.end.y, 2));
        if (distance <= 7) {
          overProbe = probe;
          return true; // Breaking out of the loop
        }
        return false;
      });

      if (overProbe) {
        setCurrentProbe(overProbe);
        const boundingRect = imageElement.current.getBoundingClientRect();
        const relativeX = event.clientX - boundingRect.left;
        const relativeY = event.clientY - boundingRect.top;
        showContextMenu(relativeX, relativeY);
      }
    }
  }

  const showContextMenu = (x, y) => {
    const menu = contextMenuRef.current; // use the ref here
    menu.style.top = `${y + 10}px`;
    menu.style.left = `${x + 10}px`;
    menu.style.display = 'block';
    menu.style.opacity = 0;
    setTimeout(() => menu.style.opacity = 1, 50);
  }

  const hideContextMenu = () => {
    const menu = contextMenuRef.current; // use the ref here
    menu.style.display = 'none';
  }

  const deleteProbe = () => {
    const probes = cornerstoneTools.getToolState(imageElement.current, 'Probe');
    if (probes && probes.data) {
      const index = probes.data.indexOf(currentProbe);
      if (index > -1) {
        probes.data.splice(index, 1);
        cornerstone.updateImage(imageElement.current);  // Redraw the image with updated tool state
        getToolsState()
      }
    }
    hideContextMenu();
  }

  return (
    <div style={{ position: 'relative' }}>
      <div
        ref={imageElement}
        style={{ width: '100%', height: 'calc(100vh - 120px)' }}
        onClick={hideContextMenu}
      ></div>
      <div
        ref={contextMenuRef} // attach the ref here
        style={{
          display: 'none',
          position: 'absolute',
          backgroundColor: 'white',
          border: '1px solid #ccc',  // Light gray border
          borderRadius: '5px',       // Rounded corners
          boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.1)',  // Drop shadow
          transition: 'opacity 0.2s ease-in-out',        // Smooth fade-in effect
          zIndex: 1000
        }}
      >
        <div
          style={{
            padding: '10px',
            cursor: 'pointer',
            borderBottom: '1px solid #eee'  // Subtle bottom border
          }}
          onClick={deleteProbe}
        >
          Delete this probe?
        </div>
      </div>
    </div>
  );
}
